import { useEffect } from "react";
import { Graph } from "../graph/Graph";
import { Interval } from "../navigation/tabs/TabsTypes";
import { GraphType } from "../graph/GraphTypes";
import { timestampToDate } from "../helpers/DateHelper";
import classes from "./PWOSHEStats.module.css"; // on peut réutiliser les mêmes styles
import i18n from "../i18n";

interface PWOSHEProps {
  startDate: number;
  endDate: number;
  serial: string;
  title: string;
}

export const PWOSHEStats = ({ startDate, endDate, serial, title }: PWOSHEProps) => {
  useEffect(() => {
    const timer = setInterval(() => {
      console.log("[PWOSHEStats] Refetching data every 15 seconds");
      // Ajouter ici un appel à la fonction de refresh de données si besoin
    }, 15000);
    return () => clearInterval(timer);
  }, []);

  return (
    <>
      {/* Per-Hour view */}
      <div className={classes.StatsContainer}>
        <label className={classes.StatsLabel}>
          {i18n.t("PWOSHEAlarms")} {timestampToDate(startDate)} {i18n.t("AlarmTo")} {timestampToDate(endDate)} – {title} ({i18n.t("PerHour")})
        </label>
        <div className={classes.TitleSeparator} />
        <div className={classes.GraphContainer}>
          <Graph
            startDatePeriodTimestamp={startDate}
            endDatePeriodTimestamp={endDate}
            interval={Interval.HOUR}
            graphType={GraphType.PWOSHE_ALARM_EVOLUTION}
            preventUpdateAnimations
            nodePath=""
            securispot={serial}
            export
          />
        </div>
      </div>

      {/* Per-Day view */}
      <div className={classes.StatsContainer}>
        <label className={classes.StatsLabel}>
          {i18n.t("PWOSHEAlarms")} {timestampToDate(startDate)} {i18n.t("AlarmTo")} {timestampToDate(endDate)} – {title} ({i18n.t("PerDay")})
        </label>
        <div className={classes.TitleSeparator} />
        <div className={classes.GraphContainer}>
          <Graph
            startDatePeriodTimestamp={startDate}
            endDatePeriodTimestamp={endDate}
            interval={Interval.DAY}
            graphType={GraphType.PWOSHE_ALARM_EVOLUTION}
            preventUpdateAnimations
            nodePath=""
            securispot={serial}
            export
          />
        </div>
      </div>

    </>
  );
};
